import { render, staticRenderFns } from "./allocateInventory.vue?vue&type=template&id=da25fb14"
import script from "./allocateInventory.vue?vue&type=script&lang=ts"
export * from "./allocateInventory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports